import React from 'react';
import { Switch, Route } from "react-router-dom";
import { HomeMain } from '.';

export const HomeRouter = (props) => {
  return <div>
    <Switch>
        <Route exact path={"/home"} component={HomeMain} />
      </Switch>
  </div>;
};
